var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lenio-text",
    xmlns: "http://www.w3.org/2000/svg",
    width: 208.905,
    height: 50.914,
    viewBox: "0 0 208.905 50.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LITTLEbig_Logo_final-05",
    transform: "translate(-19.37 -16.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "yellow-icon",
    "data-name": "Group 712",
    transform: "translate(213.911 16.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3519",
    "data-name": "Path 3519",
    d: "M2166.109,16.83a.569.569,0,0,0-.4.165l-1.589,1.588a.563.563,0,0,0,0,.794l3.309,3.307-3.309,3.308a.562.562,0,0,0,0,.793l1.589,1.588a.563.563,0,0,0,.795,0l5.292-5.292a.563.563,0,0,0,0-.795L2166.506,17a.569.569,0,0,0-.4-.165Z",
    transform: "translate(-2163.959 -16.83)",
    fill: "#f7b208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3520",
    "data-name": "Path 3520",
    d: "M2231.726,114.1s-.564.582-.638.634a.962.962,0,0,1-1.418-.217c-.21-.238-1.529-1.562-1.529-1.562l1.253-1.248,2.333,2.392Z",
    transform: "translate(-2222.318 -103.103)",
    fill: "#f7b208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3521",
    "data-name": "Path 3521",
    d: "M2241.938,22.287,2236.646,17a.561.561,0,0,0-.795,0l-1.588,1.588a.562.562,0,0,0,0,.794l3.308,3.307-1.724,1.724,2.362,2.414,3.727-3.741a.563.563,0,0,0,0-.795Z",
    transform: "translate(-2227.737 -16.83)",
    fill: "#f7b208"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(146.047 17.326)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lenio-letter",
    id: "B",
    "data-name": "Path 3522",
    d: "M1417.014,54.941v8.665h-1.174V22.3h1.174V44.32a13.158,13.158,0,0,1,12.913-9.335c8.106,0,13.975,6.485,13.975,14.59v.112c0,8.105-5.87,14.59-13.975,14.59a13.158,13.158,0,0,1-12.913-9.335Zm25.659-5.2v-.112c0-7.435-5.142-13.528-12.8-13.528s-12.913,6.2-12.913,13.472v.112c0,7.211,5.367,13.472,12.913,13.472S1442.673,57.233,1442.673,49.742Z",
    transform: "translate(-1415.84 -22.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lenio-letter",
    id: "I2",
    "data-name": "Path 3523",
    d: "M1786.2,164.01h1.174v28.451H1786.2Z",
    transform: "translate(-1752.604 -151.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lenio-letter",
    id: "G",
    "data-name": "Path 3524",
    d: "M1861.436,195.559l.727-.951a19.074,19.074,0,0,0,11.963,4.137c7.435,0,12.411-4.248,12.411-12.466v-5.7a13.63,13.63,0,0,1-12.578,8.105c-7.6,0-13.807-5.925-13.807-13.192v-.112c0-7.268,6.206-13.249,13.807-13.249a13.631,13.631,0,0,1,12.578,8.105V162.8h1.174v23.7c0,4.193-1.285,7.491-3.578,9.782-2.348,2.348-5.87,3.578-10.007,3.578A20.713,20.713,0,0,1,1861.436,195.559Zm25.212-20.013v-.112a12.534,12.534,0,0,0-12.634-12.186,12.318,12.318,0,0,0-12.578,12.075v.112a12.365,12.365,0,0,0,12.578,12.131C1881,187.565,1886.647,182.086,1886.647,175.546Z",
    transform: "translate(-1819.846 -149.446)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    transform: "translate(19.37 30.055)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lenio-letter",
    id: "L",
    "data-name": "Path 3525",
    d: "M19.37,162.62h3.386v25.4H35.821v3.145H19.37Z",
    transform: "translate(-19.37 -162.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lenio-letter",
    id: "I",
    "data-name": "Path 3526",
    d: "M250.51,162.62H253.9v28.547H250.51Z",
    transform: "translate(-229.543 -162.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lenio-letter",
    id: "T",
    "data-name": "Path 3527",
    d: "M362.987,165.765h-9.435v25.4h-3.387v-25.4H340.73V162.62h22.257Z",
    transform: "translate(-311.579 -162.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lenio-letter",
    id: "T2",
    "data-name": "Path 3528",
    d: "M627.017,165.765h-9.435v25.4H614.2v-25.4H604.76V162.62h22.257Z",
    transform: "translate(-551.658 -162.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lenio-letter",
    id: "L2",
    "data-name": "Path 3529",
    d: "M903,162.62h3.386v25.4h13.064v3.145H903V162.62Z",
    transform: "translate(-822.844 -162.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lenio-letter",
    id: "E",
    "data-name": "Path 3530",
    d: "M1134.15,162.62h17.943v3.145h-14.556v8.951h13.588v3.145h-13.588v10.161h15.281v3.145H1134.15Z",
    transform: "translate(-1033.026 -162.62)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2b75a38d194d4e48af842ff4ee60b8bd.svg";
export { ForwardRef as ReactComponent };